import React from 'react';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'; 
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';

const getChangeIcon = (change) => {
  // Check if the change is undefined, null, or "N/A"
  if (change === undefined || change === null || change === "N/A") {
    return <span>N/A</span>;
  }

  const changeNum = Number(change);
  if (changeNum === 0) {
    return <span>0</span>;
  }

  const isPositive = changeNum > 0;

  const icon = isPositive ? (
    <ArrowCircleUpIcon sx={{ color: "#A08974", verticalAlign: "middle" }} />
  ) : (
    <ArrowCircleDownIcon sx={{ color: "#F1E0C5", verticalAlign: "middle" }} />
  );

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
      {change}{icon}
    </span>
  );
};

export default getChangeIcon;

